import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants';
import type {
  UtlFncTrmInquiryProductTermsRequest,
  UtlFncTrmInquiryProductTermsResponse,
  UtlFncTrmInquiryTermsRequest,
  UtlFncTrmInquiryTermsResponse,
} from '../../types';

export const useUtlFncTrmInquiryTerms = (
  mutationOptions?: UseRestPostMutationOptions<
    UtlFncTrmInquiryTermsRequest,
    UtlFncTrmInquiryTermsResponse
  >,
) => {
  return useRestPost<UtlFncTrmInquiryTermsRequest, UtlFncTrmInquiryTermsResponse>(
    { endpoint: APIS.utilities.functions.terms.inquiryTerms },
    mutationOptions,
  );
};

export const useUtlFncTrmInquiryProductTerms = (
  mutationOptions?: UseRestPostMutationOptions<
    UtlFncTrmInquiryProductTermsRequest,
    UtlFncTrmInquiryProductTermsResponse
  >,
) => {
  return useRestPost<UtlFncTrmInquiryProductTermsRequest, UtlFncTrmInquiryProductTermsResponse>(
    { endpoint: APIS.utilities.functions.terms.inquiryProductTerms },
    mutationOptions,
  );
};
